import { newToolFilterOAuthMcp } from "../oauth.ts";

export const prismaPostgresMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://www.prisma.io/apple-icon.png",
  url: "https://mcp.prisma.io/mcp",
  label: "Prisma Postgres",
});
